/* eslint-disable react/require-default-props */
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { ReactElement } from 'react';
import { IoCloseSharp } from 'react-icons/io5';

import { ModalInfo, Button } from '~/components';

import * as S from './styles';

interface IConfirmModalProps {
  title: string;
  textContent?: string;
  confirmText?: string;
  children?: ReactNode;
  modalIsVisible: boolean;
  setModalIsVisible: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
}

function ConfirmModal({
  title,
  textContent,
  confirmText,
  children,
  modalIsVisible,
  setModalIsVisible,
  handleSubmit,
}: IConfirmModalProps): ReactElement {
  return (
    <ModalInfo
      modalVisible={modalIsVisible}
      setModalVisible={setModalIsVisible}
      containerStyle={{
        justifyContent: 'flex-start',
        padding: '3rem',
        alignItems: 'flex-start',
      }}
    >
      <S.ConfirmDeleteContainer>
        <S.HeaderContainer>
          <S.ConfirmDeleteTitle>{title}</S.ConfirmDeleteTitle>
          <IoCloseSharp
            style={{ cursor: 'pointer' }}
            size={30}
            onClick={() => setModalIsVisible(!modalIsVisible)}
          />
        </S.HeaderContainer>
        <S.Divider />
        <S.ConfirmDeleteText>{textContent}</S.ConfirmDeleteText>
        {children}
        <S.ConfirmDeleteButtonGroup>
          <Button
            size="small"
            textContent="Cancelar"
            onClick={() => setModalIsVisible(false)}
            variant="red"
            extraStyles={{
              maxWidth: '200px',
              maxHeight: 35,
            }}
          />
          <Button
            size="small"
            textContent={confirmText ?? 'Confirmar'}
            onClick={handleSubmit}
            variant="black"
            extraStyles={{
              maxWidth: '200px',
              maxHeight: 35,
              marginLeft: 17,
            }}
          />
        </S.ConfirmDeleteButtonGroup>
      </S.ConfirmDeleteContainer>
    </ModalInfo>
  );
}

export default ConfirmModal;
